export default "__VITE_ASSET__BvPEQKMe__"